"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEpoch = exports.updateEpoch = void 0;
const tslib_1 = require("tslib");
const ImpactProvider_1 = require("./ImpactProvider");
const contracts_1 = require("./contracts");
const updater_1 = require("./updater");
const react_1 = tslib_1.__importStar(require("react"));
const updateEpoch = async (provider, networkId, address) => {
    if (!address) {
        return;
    }
    const { donationMiner } = (0, contracts_1.getContracts)(provider, networkId);
    const [epochData, userContributionData, donations] = await Promise.all([
        (0, updater_1.updateEpochData)(provider, donationMiner),
        (0, updater_1.updateUserContributionData)(provider, donationMiner, address),
        (0, updater_1.getLastEpochsDonations)(donationMiner, address)
    ]);
    return Object.assign(Object.assign(Object.assign({}, epochData), userContributionData), { donations });
};
exports.updateEpoch = updateEpoch;
const useEpoch = () => {
    const { provider, address, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    const { epoch, setEpoch } = react_1.default.useContext(ImpactProvider_1.EpochContext);
    (0, react_1.useEffect)(() => {
        if (address) {
            (0, exports.updateEpoch)(provider, networkId, address).then(epochData => {
                setEpoch(epoch => (Object.assign(Object.assign(Object.assign({}, epoch), epochData), { initialised: true })));
            });
        }
    }, []);
    return { epoch };
};
exports.useEpoch = useEpoch;
//# sourceMappingURL=useEpoch.js.map